<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div>
    <!--  query option area start .......... -->

    <v-container>
      <v-form ref="queryForm" v-model="queryFormValid"  >

        <v-row dense align="center">
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <v-text-field :rules="[v => !v || v.length <= 128 || '长度不得超过128',]" v-model="pagedQueryRequest.hospEqpId"
                          label="设备编号" @keyup.enter="pagedQuery" :hide-details="true"></v-text-field>
          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <z-source-selector
                source="HospSelector"
                :hide-details=true
                label="医院"
                v-model="pagedQueryRequest.hospId"/>
          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <z-source-selector
                source="DeptSelector"
                :hide-details=true
                label="部门"
                v-model="pagedQueryRequest.deptId"/>
          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <v-text-field :rules="[v => !v || v.length <= 128 || '长度不得超过128',]" v-model="pagedQueryRequest.eqpName"
                          label="设备名称" @keyup.enter="pagedQuery" :hide-details="true"></v-text-field>
          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <v-text-field :rules="[v => !v || v.length <= 64 || '长度不得超过64',]" v-model="pagedQueryRequest.eqpBrand"
                          label="品牌" @keyup.enter="pagedQuery" :hide-details="true"></v-text-field>
          </v-col>
          <v-col md="3" lg="2" xl="2" sm="6" xs="12" style="margin-top: 10px">
            <v-btn
                :loading="queryLoading"
                :disabled="queryLoading"
                color="primary"
                dark
                class="mr-2 ml-2"
                @click="pagedQuery"
            >
              搜索
              <v-icon small right dark>search</v-icon>
            </v-btn>
            <v-btn
                color="primary"
                class="md-2"
                @click="Object.assign(pagedQueryRequest, $options.data().pagedQueryRequest) || pagedQuery()"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <v-text-field :rules="[v => !v || v.length <= 256 || '长度不得超过256',]" v-model="pagedQueryRequest.eqpModel"
                          label="型号" @keyup.enter="pagedQuery" :hide-details="true"></v-text-field>
          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">

            <z-source-selector
                param="DAQ_TYPE"
                source="DicSelector"
                :hide-details=true
                label="运行参数类型"
                v-model="pagedQueryRequest.daqType"/>
          </v-col>
          <v-col md="2" lg="2" xl="2" sm="6" xs="12">
            <v-text-field :rules="[v => !v || v.length <= 64 || '长度不得超过64',]" v-model="pagedQueryRequest.factSerialNo"
                          label="出厂序列号" @keyup.enter="pagedQuery" :hide-details="true"></v-text-field>
          </v-col>
          <v-col md="2" lg="6" xl="2" sm="6" xs="12">
            <z-select-date label="入网"
                           :startDateRules="[]"
                           :endDateRules="[]"
                           v-model="pagedQueryRequest.createDateTime" :hide-details="true"></z-select-date>
          </v-col>
        </v-row>
        <v-expand-transition>
          <v-row v-show="searchExpand" dense align="center">
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 128 || '长度不得超过128',]" v-model="pagedQueryRequest.remark"
                            label="备注信息" @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="pagedQueryRequest.companyId"
                            label="公司id" @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 19 || '长度不得超过19',]"
                            v-model="pagedQueryRequest.createDateTime" label="创建时间"
                            @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 19 || '长度不得超过19',]"
                            v-model="pagedQueryRequest.updateDateTime" label="上次更新时间"
                            @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 3 || '长度不得超过3',]" v-model="pagedQueryRequest.daqType"
                            label="采集类型" @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="pagedQueryRequest.deptId"
                            label="科室id" @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
            <v-col md="2" lg="1" xl="1" sm="6" xs="12">
              <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="pagedQueryRequest.roomId"
                            label="房间id" @keyup.enter="pagedQuery"></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

      </v-form>
    </v-container>
    <!--  query option area end .......... -->
    <v-row class="d-flex justify-center">

      <v-col
          :sm="11"
          :xs="12"
          cols="11">
        <!--  data table area start .......... -->
        <v-data-table
            ref="table"
            :headers="tableHeaders"
            :items="dataList"
            item-key="id"
            v-model="selectedDataList"
            show-expand
            single-expand
            @item-expanded="eqpDetailsQuery"
            :loading="queryLoading"
            :server-items-length="queryResultTotal"
            :options.sync="tableOptions"
            :footer-props=" { itemsPerPageOptions:[10,30,100,300] }"

        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">

              <div style="display:flex;align-items: flex-start;justify-content: space-between">
                <div style="width:30%;">
                  <div style="padding:10px 0;">
                    <span>访问地址:</span>{{ eqpDetailsInfo.url }}
                  </div>
                  <div v-show="item.daqType == '04'" style="padding:10px 0;">
                    <span>端口:</span>{{ eqpDetailsInfo.port }}
                  </div>
                  <div style="padding:10px 0;">
                    <span>登录用户名:</span>{{ eqpDetailsInfo.userName }}
                  </div>
                  <div style="padding:10px 0;">
                    <span>密码:</span>{{ eqpDetailsInfo.password }}
                  </div>
                  <v-btn color="primary" @click="paramConfigUpdate(item.daqType)">修改参数</v-btn>
                </div>
                <div style="width:70%;">
                  <div style="padding:10px 0;display:flex;align-items: flex-start;justify-content: flex-start">
                    <div style="margin-right:5px;">预警通知人:</div>
                    <div>
                      <div v-for="(obj,index) in item.notifierList"
                           :key="index">
                        <span>{{obj.acctName}}</span>
                        <span style="padding:0 5px;">{{obj.acctPhone}}</span>
                        <span>{{'微信'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </td>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-3" @click="handleEditItem(item)">mdi-pencil</v-icon>
            <v-icon small class="mr-3" @click="handleDeleteItem(item)">mdi-delete</v-icon>
            <v-icon small class="mr-3" @click="handleCopyCreateItem(item)">library_add</v-icon>
            <v-icon
                small
                v-clipboard:copy="getCopyData([item])"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyFail"
            >content_copy
            </v-icon>
          </template>
          <template v-slot:no-data>
            <span>没有数据</span>
          </template>
          <template v-slot:item.daqType="{ item ,index}">
            <z-source-selector
                id="test1"
                param="DAQ_TYPE"
                source="DicSelector"
                :hide-details=true
                :dense="true"
                :outlined="true"
                label="待录入"
                :single-line=true
                @changevalue="daqTypeChange(item)"
                v-model="item.daqType"/>
          </template>daqWarnEditDialog
          <template  v-slot:item.opr="{ item ,index}">
            <v-btn
                :disabled="item.daqType ==null"
                color="primary"
                class="mr-2 ml-2 mt-2"
                @click="daqWarnEditQuery(item)"
            >
              配置
            </v-btn>

            <!--注释iot4期 start-->
            <v-btn
                    @click="showWarningConfigDialog(item)"
                    color="primary"
                    class="mr-2 ml-2 mb-2 mt-2"
            >
              预警通知
            </v-btn>
            <!--注释iot4期 end-->

          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--  data table area end .......... -->


    <!--预警通知dialog start-->
    <v-dialog v-model="warningConfigDialog"
              persistent
              max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">预警通知配置</span>
        </v-card-title>
        <v-card-text>
          <v-form
                  ref="warningRulesForm"
                  v-model="warningRulesForm.valid"
          >
            <!--<div>-->
              <!--<Z-Source-Selector-->
                      <!--label="消息推送渠道:"-->
                      <!--required-->
                      <!--:rules="[v => !!v || '类型必选']"-->
                      <!--source="DicSelector"-->
                      <!--param="NOTIFY_TYPE"-->
                      <!--v-model="warningRulesForm.notifyType">-->
              <!--</Z-Source-Selector>-->
            <!--</div>-->

            <v-row v-for="(item,index) in warningRulesForm.notifier"
                   align="center"
                   :key="index">
              <v-col :cols="1">
                {{index+1}}.
              </v-col>
              <v-col :cols="8">
                <v-text-field
                        class="pt-0"
                        v-model="item.acctPhone"
                        counter="11"
                        :rules="phoneRules"
                        :error="item.isRepeat"
                        :error-messages="item.repeatMsg"
                        label="请输入手机号"
                        clearable
                        :maxLength="11"
                        @click:append="queryPerson(item,index)"
                        @change="queryPerson(item,index)"
                        append-icon="search"
                        required
                ></v-text-field>
                <v-text-field
                        class="pt-2"
                        v-model="item.acctName"
                        v-show="true"
                        disabled
                        :rules="[v => !!v || '姓名必存在']"
                        label="手机号所属人(输入手机号后自动返显)"
                        required
                ></v-text-field>
              </v-col>
              <v-col :cols="3" class="flex-view-style">
                <v-btn icon color="primary"
                       @click="removeContactPerson(index)">
                  <v-icon dark>remove_circle</v-icon>
                </v-btn>
                <v-btn icon color="primary"
                       v-if="index==warningRulesForm.notifier.length-1"
                       @click="addContactPerson">
                  <v-icon dark>add_circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <span v-if="!warningRulesForm.notifier||warningRulesForm.notifier.length==0">增加消息通知人：</span>

            <v-btn icon color="primary"
                   v-if="!warningRulesForm.notifier||warningRulesForm.notifier.length==0"
                   @click="addContactPerson">
              <v-icon dark>add_circle</v-icon>
            </v-btn>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="warningConfigDialog = false">取消</v-btn>
          <v-btn color="primary" text @click="confirmWarningRules">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--预警通知dialog end-->

    <!--  create dialog start .......... -->
    <v-dialog v-model="createDialog" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">添加新的医院设备表</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="createForm" v-model="createFormValid">
            <v-container>
              <v-row>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]"
                                v-model="createRequest.eqpExternalId" label="外部系统id"
                                @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '设备名称为必输项',v => !v || v.length <= 128 || '长度不得超过128',]"
                                v-model="createRequest.eqpName" label="设备名称" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '型号为必输项',v => !v || v.length <= 256 || '长度不得超过256',]"
                                v-model="createRequest.eqpModel" label="型号" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '品牌为必输项',v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="createRequest.eqpBrand" label="品牌" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '院内编号为必输项',v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="createRequest.hospEqpId" label="院内编号" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '出厂序列号为必输项',v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="createRequest.factSerialNo" label="出厂序列号"
                                @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 2 || '长度不得超过2',]" v-model="createRequest.eqpState"
                                label="设备状态" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 256 || '长度不得超过256',]" v-model="createRequest.eqpType"
                                label="设备类型" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 128 || '长度不得超过128',]" v-model="createRequest.remark"
                                label="备注信息" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '公司id为必输项',v => !v || v.length <= 24 || '长度不得超过24',]"
                                v-model="createRequest.companyId" label="公司id" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 19 || '长度不得超过19',]"
                                v-model="createRequest.updateDateTime" label="上次更新时间"
                                @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 3 || '长度不得超过3',]" v-model="createRequest.daqType"
                                label="采集类型" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="createRequest.deptId"
                                label="科室id" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="createRequest.roomId"
                                label="房间id" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text @click="createDialog = false">取消</v-btn>
          <v-btn dark text @click="createCommit">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  create dialog end .......... -->

    <!--  delete dialog start .......... -->
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">是否刪除该项?</v-card-title>
        <!-- you can add some delete tips here-->
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text @click="deleteDialog = false">取消</v-btn>
          <v-btn dark text @click="deleteCommit()">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog end .......... -->

    <!-- update dialog start .......... -->
    <v-dialog v-model="updateDialog" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">修改医院设备表</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="updateForm" v-model="updateFormValid">
            <v-container>
              <v-row>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]"
                                v-model="updateRequest.eqpExternalId" label="外部系统id"
                                @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '设备名称为必输项',v => !v || v.length <= 128 || '长度不得超过128',]"
                                v-model="updateRequest.eqpName" label="设备名称" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '型号为必输项',v => !v || v.length <= 256 || '长度不得超过256',]"
                                v-model="updateRequest.eqpModel" label="型号" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '品牌为必输项',v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="updateRequest.eqpBrand" label="品牌" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '院内编号为必输项',v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="updateRequest.hospEqpId" label="院内编号" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '出厂序列号为必输项',v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="updateRequest.factSerialNo" label="出厂序列号"
                                @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 2 || '长度不得超过2',]" v-model="updateRequest.eqpState"
                                label="设备状态" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 256 || '长度不得超过256',]" v-model="updateRequest.eqpType"
                                label="设备类型" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 128 || '长度不得超过128',]" v-model="updateRequest.remark"
                                label="备注信息" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => v != null || '公司id为必输项',v => !v || v.length <= 24 || '长度不得超过24',]"
                                v-model="updateRequest.companyId" label="公司id" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 19 || '长度不得超过19',]"
                                v-model="updateRequest.updateDateTime" label="上次更新时间"
                                @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 3 || '长度不得超过3',]" v-model="updateRequest.daqType"
                                label="采集类型" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="updateRequest.deptId"
                                label="科室id" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 24 || '长度不得超过24',]" v-model="updateRequest.roomId"
                                label="房间id" @keyup.enter="pagedQuery"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text @click="updateDialog = false">取消</v-btn>
          <v-btn dark
                 :disabled="!updateFormValid ||  Object.keys($compChangedToNewObject(tableUpdateOriginalItem,updateRequest)).length == 0"
                 text @click="updateCommit">提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- update dialog end .......... -->

    <!--  paramConfigDialog  start .......... -->
    <v-dialog v-model="paramConfigDialog" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">设备地址 参数配置</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="paramConfigForm" v-model="paramFormValid">
            <v-container>
              <v-row>
                <v-col md="6" lg="7" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !!v || '访问地址不能为空']"
                                v-model="defUrlConfigRequest.url" label="访问地址"></v-text-field>
                </v-col>
                <v-col md="6" lg="7" xl="6" sm="12" xs="12" v-if="this.paramConfigDaqType=='04' ">
                  <v-text-field :rules="[v => !v || v.length <= 6 || '端口不可大于6位',]"
                                v-model="defUrlConfigRequest.port" label="端口"></v-text-field>
                </v-col>
                <v-col md="6" lg="7" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !!v || '登录用户名不能为空']"
                                v-model="defUrlConfigRequest.userName" label="登录用户名"></v-text-field>
                </v-col>
                <v-col md="6" lg="7" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !!v || '登录密码不能为空']"
                                v-model="defUrlConfigRequest.password" label="登录密码"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="paramConfigCancel(currentDataListIndex)">取消</v-btn>
          <v-btn color="primary" text @click="paramConfigCommit">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--  paramConfigDialog  start .......... -->
    <v-dialog v-model="daqWarnEditDialog"  max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">可配置项修改</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="daqWarnEditForm" v-model="daqWarnEditValid">
            <v-container>
              <v-row>
                <v-col v-for="(item,index) in daqWarnValueEditInfo.daqWarnValueEditList"
                       :key="index"
                       md="4"
                       sm="4"
                       cols="12"
                       class="text-center">
                  <div style="padding:0.5rem;border:1px solid #ddd;
                                border-radius: 0.5rem;position:relative;">
                    <div class="text-center">
                      <span>{{item.columnDesc}}</span>
                    </div>
                    <v-form
                        :ref="'form'+index"
                    >
                      <v-text-field
                          label="最低值"
                          v-model="item.lowValue"
                          :rules="[v => /^[1-9][0-9]*(\.[0-9]{1,2})?$/.test(v) || '格式不正确,只支持整数或者小数(保留两位)']"
                          required
                      ></v-text-field>
                      <v-text-field
                          label="最高值"
                          v-model="item.highValue"
                          :rules="[v => /^[1-9][0-9]*(\.[0-9]{1,2})?$/.test(v) || '格式不正确,只支持整数或者小数(保留两位)']"
                          required
                      ></v-text-field>
                    </v-form>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="daqWarnEdit(item,index)">
                      修改
                    </v-btn>
                  </div>

                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="daqWarnEditDialog = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <z-notify ref="notify"></z-notify>

    <z-loading v-model="loading.isLoading"></z-loading>

  </div>
</template>

<script>
import eqpApi, {daqWarnEditQuery, geMrUrlUpdate, queryMrUrlByEqpId, notifierQuery, philipsMrUrlUpdate, siemensCtUrlUpdate, geCtUrlUpdate,querySiemensCtUrlByEqpId, philipCtUrlUpdate, queryPhilipsMrUrlByEqpId, queryGeCtUrlByEqpId, queryPhilipsCtUrlByEqpId} from "@/api/eqp";
import ZSourceSelector from "@/components/ZSourceSelector"
import ZSelectDate from "@/components/ZSelectDate"
import ZLoading from "@/components/ZLoading"

export default {
  name: "Eqp",
  data: () => ({
    // 数据中id的属性名称
    idKey: 'id',
    /** form valid model  */
    queryFormValid: false,
    createFormValid: false,
    updateFormValid: false,
    paramFormValid: true,
    daqWarnEditValid: true,
    /** loading status */
    queryLoading: false,
    /** dialog status */
    createDialog: false,
    updateDialog: false,
    deleteDialog: false,
    paramConfigDialog: false,
    paramConfigDaqType: '',
    daqWarnEditDialog:false,
    /** 额外查询条件区域 show-flag */
    searchExpand: false,
    /** data-table */
    tableOptions: {},
    tableExpandInfo:{},
    tableHeaders: [
      {text: "", value: "data-table-expand"},
      {text: "设备编号", value: "hospEqpId"},
      {text: "机构", value: "hospName"},
      {text: "部门", value: "deptName"},
      {text: "设备名称", value: "eqpName"},
      {text: "型号", value: "eqpModel"},
      {text: "品牌", value: "eqpBrand"},
      {text: "出厂序列号", value: "factSerialNo"},
      {text: "运行参数类型", value: "daqType", width: "200"},
      {text: "采集器MAC", value: "collectorMac"},
      {text: "入网时间", value: "createDateTime"},
      {text: "操作", value: "opr"},
    ],
    dataList: [],
    selectedDataList: [],
    queryResultTotal: 0,
    /** api object */
    pagedQueryRequest: {
      id: null, //设备id
      eqpExternalId: null, //外部系统id
      eqpName: null, //设备名称
      eqpModel: null, //型号
      eqpBrand: null, //品牌
      hospEqpId: null, //院内编号
      factSerialNo: null, //出厂序列号
      eqpState: null, //设备状态
      eqpType: null, //设备类型
      remark: null, //备注信息
      companyId: null, //公司id
      createDateTime: [], //创建时间
      daqType: null, //采集类型
      deptId: null, //科室id
      roomId: null, //房间id
      hosp: null,//医院
      pagedQueryInfo: {
        index: 1,
        pageSize: 10,
      },
      sortBy: "",
      sortAsc: null,
    },
    createRequest: {
      eqpExternalId: null, //外部系统id
      eqpName: null, //设备名称
      eqpModel: null, //型号
      eqpBrand: null, //品牌
      hospEqpId: null, //院内编号
      factSerialNo: null, //出厂序列号
      eqpState: null, //设备状态
      eqpType: null, //设备类型
      remark: null, //备注信息
      companyId: null, //公司id
      updateDateTime: null, //上次更新时间
      daqType: null, //采集类型
      deptId: null, //科室id
      roomId: null, //房间id
    },
    updateRequest: {
      id: null, //设备id
      eqpExternalId: null, //外部系统id
      eqpName: null, //设备名称
      eqpModel: null, //型号
      eqpBrand: null, //品牌
      hospEqpId: null, //院内编号
      factSerialNo: null, //出厂序列号
      eqpState: null, //设备状态
      eqpType: null, //设备类型
      remark: null, //备注信息
      companyId: null, //公司id
      updateDateTime: null, //上次更新时间
      daqType: null, //采集类型
      deptId: null, //科室id
      roomId: null, //房间id
    },
    defUrlConfigRequest: {
      "id": "",
      "eqpId": "",
      "port": null,
      "url": "",
      "password": "",
      "userName": "",
    },
    daqTypeUpdateRequest: {
      "eqpId": "",
      "daqType":"",
    },
    daqWarnEditQueryRequest:{
      "eqpId": "",
      "daqType": ""
    },
    daqWarnEditRequest:{
      "eqpId": "",
      "daqType": "",
      "daqWarnValueEdit": {
        "column": "",
        "columnDesc": "",
        "highValue": 0,
        "id": "",
        "lowValue": 0,
        "notifier": "",
        "notifierName": ""
      }
    },
    eqpDetailsInfo: {},
    currentDataListIndex: 0,
    /** operate temp object */
    tobeDeleteItem: {},
    tableUpdateOriginalItem: {},
    daqWarnValueEditInfo: {
      "daqType": "",
      "daqWarnValueEditList": [
        {
          "column": "",
          "columnDesc": "",
          "highValue": 0,
          "id": "",
          "lowValue": 0,
          "notifier": "",
          "notifierName": ""
        }
      ],
      "eqpId": ""
    },
    warningConfigDialog:false,
    warningRulesForm:{
      valid:true,
      notifyType:'',
      notifier:[
        // {
        //   acctPhone:'13052588181',
        //   acctName:"李"
        // }
      ]
    },
    phoneRules: [
      v => !!v || '手机号必输',
      v => /1\d{10}/.test(v) || '手机号格式不正确',
      v => !!v && v.length <= 11 || '最多11位数'
    ],
    loading:{
      isLoading:false
    }
  }),
  components: {
    ZSourceSelector,
    ZSelectDate,
    ZLoading
  },
  created() {
    this.initialize();
  },
  watch: {
    'warningRulesForm.valid': {
      handler: function (newValue, oldValue) {
        // alert(newValue, '预警参数配置变化');
      }
    },
    tableOptions: {
      handler() {
        this.pagedQuery();
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.pagedQuery();
    },
    pagedQuery() {
      this.queryLoading = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.tableOptions;
      console.log(this.tableOptions)
      this.pagedQueryRequest.sortBy =
          sortBy && sortBy.length === 1 ? sortBy[0] : null;
      this.pagedQueryRequest.sortAsc =
          sortDesc && sortDesc.length === 1 ? !sortDesc[0] : null;
      this.pagedQueryRequest.pagedQueryInfo.index = page;
      this.pagedQueryRequest.pagedQueryInfo.pageSize = itemsPerPage;
      eqpApi
          .pagedQuery(this.pagedQueryRequest)
          .then((res) => {
            this.dataList = res.list;
            this.queryResultTotal = res.total;
            this.queryLoading = false;
          })
          .catch((err) => {
            this.queryLoading = false;
            console.error(err);
          });
    },
    createCommit() {
      if (this.$refs.createForm.validate()) {
        this.createDialog = false;
        eqpApi
            .create(this.createRequest)
            .then(() => {
              this.$snackInfo("添加成功");
              this.pagedQuery();
            })
            .catch((err) => {
              this.createDialog = false;
              console.error(err);
            });
      }
    },
    handleCreateItem(item) {
      this.createRequest = Object.assign(this.createRequest, this.$options.data().createRequest);
      this.createDialog = true;
    },
    handleEditItem(item) {
      this.updateRequest = JSON.parse(JSON.stringify(item));
      this.tableUpdateOriginalItem = JSON.parse(JSON.stringify(item));
      this.updateDialog = true;
    },
    handleDeleteItem(item) {
      this.tobeDeleteItem = item;
      this.deleteDialog = true;
    },
    handleCopyCreateItem(item) {
      this.createRequest = JSON.parse(JSON.stringify(item));
      this.createDialog = true;
    },
    updateCommit() {
      this.updateDialog = false;
      // 比较修改前数据
      let updateObject = this.$compChangedToNewObject(
          this.tableUpdateOriginalItem,
          this.updateRequest
      );
      // 设定修改对象主键/ID
      updateObject["id"] = this.tableUpdateOriginalItem["id"];
      eqpApi
          .update(updateObject)
          .then(() => {
            this.$snackInfo("更新成功");
            this.pagedQuery();
          })
          .catch((err) => {
            this.updateDialog = false;
            console.error(err);
          });
    },
    /** 拷贝数据返回 */
    getCopyData(items) {
      let rs = "";
      rs += "设备id\t";
      id:null, //设备id 
          rs += "外部系统id\t";
      eqpExternalId:null, //外部系统id 
          rs += "设备名称\t";
      eqpName:null, //设备名称 
          rs += "型号\t";
      eqpModel:null, //型号 
          rs += "品牌\t";
      eqpBrand:null, //品牌 
          rs += "院内编号\t";
      hospEqpId:null, //院内编号 
          rs += "出厂序列号\t";
      factSerialNo:null, //出厂序列号 
          rs += "设备状态\t";
      eqpState:null, //设备状态 
          rs += "设备类型\t";
      eqpType:null, //设备类型 
          rs += "备注信息\t";
      remark:null, //备注信息 
          rs += "公司id\t";
      companyId:null, //公司id 
          rs += "创建时间\t";
      createDateTime:null, //创建时间 
          rs += "上次更新时间\t";
      updateDateTime:null, //上次更新时间 
          rs += "采集类型\t";
      daqType:null, //采集类型 
          rs += "科室id\t";
      deptId:null, //科室id 
          rs += "房间id\t";
      roomId:null, //房间id 
          rs += "\n";
      items.forEach((item) => {
        rs += item.id + "\t";
        rs += item.eqpExternalId + "\t";
        rs += item.eqpName + "\t";
        rs += item.eqpModel + "\t";
        rs += item.eqpBrand + "\t";
        rs += item.hospEqpId + "\t";
        rs += item.factSerialNo + "\t";
        rs += item.eqpState + "\t";
        rs += item.eqpType + "\t";
        rs += item.remark + "\t";
        rs += item.companyId + "\t";
        rs += item.createDateTime + "\t";
        rs += item.updateDateTime + "\t";
        rs += item.daqType + "\t";
        rs += item.deptId + "\t";
        rs += item.roomId + "\t";
        rs += "\n";
      });
      return rs;
    },
    copySuccess() {
      this.$snackInfo("拷贝成功");
    },
    copyFail() {
      this.$snackError("拷贝失败");
    },
    //运行参数类型改变
    daqTypeChange(data) {
      if (data.daqType == null) {
          this.daqTypeUpdateRequest.eqpId = data.id
          this.daqTypeUpdateRequest.daqType = null
          eqpApi.daqTypeUpdate(this.daqTypeUpdateRequest).then(()=>{
              this.daqTypeUpdateRequest.eqpId = ""
              this.daqTypeUpdateRequest.daqType = ""
              this.eqpDetailsInfo= {}
          }).catch(()=>{
              this.paramConfigDialog = false;
          })
      }
      this.defUrlConfigRequest.eqpId = data.id
      this.daqTypeUpdateRequest.eqpId = data.id
      this.daqTypeUpdateRequest.daqType = data.daqType
      this.paramConfigDaqType = data.daqType
      console.log(data)
      //先查询是否存在配置信息
      let eqpIdReq = {
        eqpId: data.id
      }
      if (data.daqType == '01') {
        eqpApi.queryMrUrlByEqpId(eqpIdReq).then(res => {
            console.log(res, '-------id----')
            this.defUrlConfigRequest.id = res.id
            this.defUrlConfigRequest.url = res.url
            this.defUrlConfigRequest.userName = res.userName
            this.defUrlConfigRequest.password = res.password
        }).catch(() => {

        });
        this.paramConfigDialog = true;
        if(this.$refs.paramConfigForm != undefined){
          this.$refs.paramConfigForm.resetValidation()
        }
      }

      if (data.daqType == '02') {
        eqpApi.queryPhilipsCtUrlByEqpId(eqpIdReq).then(res => {
          console.log(res, '-------id----')
          this.defUrlConfigRequest.id = res.id
          this.defUrlConfigRequest.url = res.url
          this.defUrlConfigRequest.userName = res.userName
          this.defUrlConfigRequest.password = res.password
        }).catch(() => {

        });
        this.paramConfigDialog = true;
        if(this.$refs.paramConfigForm != undefined){
          this.$refs.paramConfigForm.resetValidation()
        }
      }

      if (data.daqType == '03') {
        eqpApi.queryPhilipsMrUrlByEqpId(eqpIdReq).then(res => {
          console.log(res, '-------id----')
          this.defUrlConfigRequest.id = res.id
          this.defUrlConfigRequest.url = res.url
          this.defUrlConfigRequest.userName = res.userName
          this.defUrlConfigRequest.password = res.password
        }).catch(() => {

        });
        this.paramConfigDialog = true;
        if(this.$refs.paramConfigForm != undefined){
          this.$refs.paramConfigForm.resetValidation()
        }
      }
      if (data.daqType == '04') {
          eqpApi.queryGeCtUrlByEqpId(eqpIdReq).then(res => {
              console.log(res, '-------id----');
              this.defUrlConfigRequest.id = res.id;
              this.defUrlConfigRequest.url = res.url;
              this.defUrlConfigRequest.port = res.port;
              this.defUrlConfigRequest.userName = res.userName;
              this.defUrlConfigRequest.password = res.password;
          }).catch(() => {

          });
          this.paramConfigDialog = true;
          if(this.$refs.paramConfigForm != undefined){
              this.$refs.paramConfigForm.resetValidation()
          }
        }

      if (data.daqType == '05') {
        eqpApi.querySiemensCtUrlByEqpId(eqpIdReq).then(res => {
          console.log(res, '-------id----')
          this.defUrlConfigRequest.id = res.id
          this.defUrlConfigRequest.url = res.url
          this.defUrlConfigRequest.userName = res.userName
          this.defUrlConfigRequest.password = res.password
        }).catch(() => {

        });
        this.paramConfigDialog = true;
        if(this.$refs.paramConfigForm != undefined){
          this.$refs.paramConfigForm.resetValidation()
        }
      }
      this.currentDataListIndex = this.dataList.indexOf(data);
    },
    //修改参数

    // 新增飞利浦MR/CT url配置
    paramConfigUpdate(daqType){
      this.defUrlConfigRequest.id = this.eqpDetailsInfo.id;
      this.defUrlConfigRequest.eqpId = this.eqpDetailsInfo.eqpId;
      this.defUrlConfigRequest.port = this.eqpDetailsInfo.port;
      this.defUrlConfigRequest.userName = this.eqpDetailsInfo.userName;
      this.defUrlConfigRequest.password = this.eqpDetailsInfo.password;
      this.defUrlConfigRequest.url = this.eqpDetailsInfo.url;
      console.log(this.defUrlConfigRequest,'--------this.defUrlConfigRequest------');
      this.paramConfigDialog = true;
      this.paramConfigDaqType = daqType;
    },
    paramConfigCommit() {
      if(this.$refs.paramConfigForm.validate()){
        if(this.daqTypeUpdateRequest.eqpId !="" ){
          debugger;
          eqpApi.daqTypeUpdate(this.daqTypeUpdateRequest).then(()=>{
            this.daqTypeUpdateRequest.eqpId = ""
            this.daqTypeUpdateRequest.daqType = ""
          }).catch(()=>{
            this.paramConfigDialog = false;
          })
        }
        if (this.paramConfigDaqType == '01') {
          eqpApi.geMrUrlUpdate(this.defUrlConfigRequest).then(res => {
              this.$refs.notify.show("提交成功", {
                  timeout: 1000,
                  color: 'success'
              });
              this.paramConfigDialog = false;
              this.eqpDetailsQuery(this.tableExpandInfo);
          }).catch(() => {
              this.paramConfigDialog = false;
          })
        }
        if (this.paramConfigDaqType == '02') {
            eqpApi.philipsCtUrlUpdate(this.defUrlConfigRequest).then(res => {
                this.$refs.notify.show("提交成功", {
                    timeout: 1000,
                    color: 'success'
                });
                this.paramConfigDialog = false;
                this.eqpDetailsQuery(this.tableExpandInfo);
            }).catch(() => {
                this.paramConfigDialog = false;
            })
        }
        if (this.paramConfigDaqType == '03') {
            eqpApi.philipsMrUrlUpdate(this.defUrlConfigRequest).then(res => {
                this.$refs.notify.show("提交成功", {
                    timeout: 1000,
                    color: 'success'
                });
                this.paramConfigDialog = false;
                this.eqpDetailsQuery(this.tableExpandInfo);
            }).catch(() => {
                this.paramConfigDialog = false;
            })
        }

        if (this.paramConfigDaqType == '04') {
          eqpApi.geCtUrlUpdate(this.defUrlConfigRequest).then(res => {
            this.$refs.notify.show("提交成功", {
                timeout: 1000,
                color: 'success'
            });
            this.paramConfigDialog = false;
            this.eqpDetailsQuery(this.tableExpandInfo);
          }).catch(() => {
              this.paramConfigDialog = false;
          })
        }
        if (this.paramConfigDaqType == '05') {
          eqpApi.siemensCtUrlUpdate(this.defUrlConfigRequest).then(res => {
            this.$refs.notify.show("提交成功", {
              timeout: 1000,
              color: 'success'
            });
            this.paramConfigDialog = false;
            this.eqpDetailsQuery(this.tableExpandInfo);
          }).catch(() => {
            this.paramConfigDialog = false;
          })
        }
      }
    },
    paramConfigCancel(data) {
      if (this.defUrlConfigRequest.id == null) {
        this.dataList[data].daqType = '';
      }
      this.paramConfigDialog = false;
    },
    //设备展开详情查询
    eqpDetailsQuery(data) {
      this.tableExpandInfo = data
      console.log(data,'------data--------')
      if (data.value) {
        let eqpIdReq = {
          eqpId: data.item.id
        }
        let index = this.dataList.indexOf(data.item)
        if (data.item.daqType == "01") {
          eqpApi.queryMrUrlByEqpId(eqpIdReq).then(res => {
              this.eqpDetailsInfo = res
              if(this.eqpDetailsInfo.eqpId == null){
                  this.eqpDetailsInfo.eqpId = data.item.id
              }
          }).catch(() => {

          });
        }
        if (data.item.daqType == "02") {
          eqpApi.queryPhilipsCtUrlByEqpId(eqpIdReq).then(res => {
            this.eqpDetailsInfo = res;
            if(this.eqpDetailsInfo.eqpId == null){
              this.eqpDetailsInfo.eqpId = data.item.id
            }
          }).catch(() => {

          });
        }
        if (data.item.daqType == "03") {
          eqpApi.queryPhilipsMrUrlByEqpId(eqpIdReq).then(res => {
            this.eqpDetailsInfo = res
            if(this.eqpDetailsInfo.eqpId == null){
              this.eqpDetailsInfo.eqpId = data.item.id
            }
          }).catch(() => {

          });
        }
        if (data.item.daqType == "04") {
          eqpApi.queryGeCtUrlByEqpId(eqpIdReq).then(res => {
            this.eqpDetailsInfo = res
            if(this.eqpDetailsInfo.eqpId == null){
                this.eqpDetailsInfo.eqpId = data.item.id
            }
          }).catch(() => {

          });
        }
        if (data.item.daqType == "05") {
          eqpApi.querySiemensCtUrlByEqpId(eqpIdReq).then(res => {
            this.eqpDetailsInfo = res
            if(this.eqpDetailsInfo.eqpId == null){
              this.eqpDetailsInfo.eqpId = data.item.id
            }
          }).catch(() => {

          });
        }
      }
    },
    //配置项查询
    daqWarnEditQuery(data){
      this.daqWarnEditQueryRequest.eqpId = data.id;
      this.daqWarnEditQueryRequest.daqType = data.daqType;
      eqpApi.daqWarnEditQuery(this.daqWarnEditQueryRequest).then(res=>{
        this.daqWarnValueEditInfo = res;
        console.log()
        this.daqWarnEditDialog = true
        this.daqWarnValueEditInfo.daqWarnValueEditList.forEach((item,index)=>{
          console.log(index,'------index----')
          console.log(this.$refs['form'+index][0],'---------this.$refs[\'form\'+index][0]----------')
          this.$refs['form'+index][0].resetValidation();
        })
      }).catch(err => {

      })
    },
    //配置项修改
    daqWarnEdit(data,index){
      if(this.$refs['form'+index][0].validate()){
        this.daqWarnEditRequest.daqType = this.daqWarnValueEditInfo.daqType
        this.daqWarnEditRequest.eqpId = this.daqWarnValueEditInfo.eqpId
        this.daqWarnEditRequest.daqWarnValueEdit = data
        eqpApi.daqWarnEdit(this.daqWarnEditRequest).then(res=>{
          this.$refs.notify.show("提交成功", {
            timeout: 1000,
            color: 'success'
          });
        }).catch(err=>{
        })
      }
    },
    showWarningConfigDialog(item){
      this.warningRulesForm={
          valid:true,
          notifyType:'',
          notifier:[]
      };
      this.warningRulesForm.eqpId=item.id;
      this.loading.isLoading=true;
      // 返显之前的配置信息
      eqpApi.eqpNotifierQuery({eqpId:item.id}).then(res => {
        console.log(res,'res');
        res.forEach(option => {
          option.isRepeat=false;
          option.repeatMsg='';
        });
        this.warningRulesForm.notifier=res;
        this.loading.isLoading=false;
        this.warningConfigDialog=true;
      }).catch(err => {

      });

      console.log(item);
    },
    // 查找消息通知人
    queryPerson(item, index) {
      console.log(item, index, '消息推送人信息');
      if (!!item.acctPhone && /1\d{10}/.test(item.acctPhone) && item.acctPhone.length < 12) {

        var indexArray=[];
        for(var i=0;i<this.warningRulesForm.notifier.length;i++){
          indexArray.push(this.warningRulesForm.notifier[i].acctPhone);
        }

        var repeatArray=this.checkRepeatArray(indexArray);
        if(repeatArray.indexOf(index)=='-1'){
          this.warningRulesForm.notifier[index].isRepeat=false;
          this.warningRulesForm.notifier[index].repeatMsg='';
          eqpApi.notifierQuery({acctPhone: item.acctPhone}).then(res => {
            if (!!res.acctName) {
              this.warningRulesForm.notifier[index].acctName = res.acctName;
              this.warningRulesForm.notifier[index].openId = res.openId;
              this.warningRulesForm.notifier[index].acctId = res.acctId;
            }
          }).catch(err => {
            // 兼容当修改手机号时并新手机号不存在时，清除老手机号对应的信息
            this.warningRulesForm.notifier[index].acctName = '';
            this.warningRulesForm.notifier[index].openId = '';
            this.warningRulesForm.notifier[index].acctId = '';
          });
        }else{
          for(var i=1;i<repeatArray.length;i=i+2){
            this.warningRulesForm.notifier[repeatArray[i]].isRepeat=true;
            this.warningRulesForm.notifier[repeatArray[i]].repeatMsg='手机号重复';
          }
        }

      } else {
        this.warningRulesForm.notifier[index].acctName = '';
      }
    },
    // 增加联系人
    addContactPerson() {
      this.warningRulesForm.notifier.push(
        {
          acctPhone: "",
          openId: "",
          acctName: "",
          acctId: '',
          isRepeat:false,
          repeatMsg:''
        }
      );
    },
    //删除联系人
    removeContactPerson(index) {
      this.warningRulesForm.notifier.splice(index, 1);
    },
    checkRepeatArray(ARR){
      var rep = [];
      ARR.forEach((item,index)=>{
        if(ARR.indexOf(item)!=index){
          rep.push(ARR.indexOf(item),index)
        }
      });
      console.log(rep,'000000000');
      return rep;
    },
    confirmWarningRules(){
      // this.checkRepeatArray(this.warningRulesForm.notifier,'===========notifier==============');
      // 之所以注释掉是因为如果原本配置了一个通知人，控制的话，后面删不掉
      // if(this.warningRulesForm.notifier.length==0){
      //   this.$refs.notify.show("至少添加一个通知人", {timeout: 1000, color: 'error'});
      //   return;
      // }

      this.$refs.warningRulesForm.validate();
      if (this.$refs.warningRulesForm.validate()) {
        eqpApi.notifyUpdate(this.warningRulesForm).then(res => {
          this.$refs.notify.show("配置成功", {timeout: 1000, color: 'success'})
          this.warningConfigDialog = false;
          this.pagedQuery();
        }).catch(err => {

        });
      }
    }
  },
};
</script>

<style scoped>
#test1 input {
  color: red;
}
</style>